import { Component } from '@angular/core';

@Component({
  selector: 'app-interest-you',
  imports: [],
  templateUrl: './interest-you.html',
  styleUrl: './interest-you.css',
})
export class InterestYou {

}
